import React from 'react';
import { Grid, PageHeader, Stack } from 'library/ui';
import FailedPayments from './Components/FailedPayments';
import PaymentsSummary from './Components/PaymentsSummary';
import PaymentMethodsSection from './Components/PaymentMethodsSection';
import MicrodepositsEntry from './Components/MicrodepositsEntry';
import InvoiceDownload from './Components/business/InvoiceDownload';
import PaymentLocationQRCodes from './Components/PaymentLocationQRCodes';
import PaymentFaq from './Components/PaymentFaq';
import LocationDiscounts from './Components/business/LocationDiscounts';
import { PermissionType, useUserContext } from 'UserContext';
import DuePayments from './Components/DuePayments';

const Payments = () => {
    const { hasPermission, user } = useUserContext();

    const canManagePayments = hasPermission(PermissionType.ManagePayments);
    const isManualPayer = user?.is_manual_payer;
    const showPaymentMethods = canManagePayments && !isManualPayer;

    return (
        <Stack gap="md">
            <PageHeader title="Payments" />
            {canManagePayments && <MicrodepositsEntry />}
            {canManagePayments && <PaymentsSummary />}
            {showPaymentMethods && <FailedPayments />}
            {canManagePayments && (
                <Grid columns={2} collapseAt="md" gap="md">
                    <DuePayments maxRows={2} />
                    <InvoiceDownload />
                </Grid>
            )}
            {showPaymentMethods && <PaymentMethodsSection />}
            <Grid columns={2} collapseAt="md" gap="md">
                <PaymentFaq />
                <PaymentLocationQRCodes />
            </Grid>
            <LocationDiscounts />
        </Stack>
    );
};

export default Payments;
